import { devStorage } from '@/configs/storages/browser';

export const isDebug =
  devStorage.getItem('is_debug') ?? import.meta.env.VITE_CONFIG_DEBUG !== '0';
